import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=5e9e6dd0&scoped=true"
import script from "./Slogan.vue?vue&type=script&lang=js"
export * from "./Slogan.vue?vue&type=script&lang=js"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=5e9e6dd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e6dd0",
  null
  
)

export default component.exports